import { render, staticRenderFns } from "./PaymentFailure.vue?vue&type=template&id=c855a79c&scoped=true&"
var script = {}
import style0 from "./PaymentFailure.vue?vue&type=style&index=0&id=c855a79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c855a79c",
  null
  
)

export default component.exports